<template>
  <div class="row">
    <div class="col-11 pt-1 pointer" @click="showDetails">
      <div>
        <span>{{ prescription.drug.name }}</span>
        <small class="ml-1">
          {{ prescription.drug.measure }}
          {{ prescription.drug.measureUnit }}
        </small>

        <small class="ml-1">
          {{ prescription.drug.manufacturer ? prescription.drug.manufacturer.name : '' }}
        </small>
      </div>

      <div>
        <small class="text-muted">{{ countPerPackage }} шт/уп, {{ packagesCount }} уп.</small>
      </div>
    </div>

    <h5 class="col-1 py-3 pl-0 text-center m-0 pointer" @click="showDetails">
      <i class="fas fa-angle-down text-secondary m-0"></i>
    </h5>

    <div class="col-12 pt-3 bg-white" v-show="details">
      <div class="row mb-2">
        <div class="col-2">
          <small class="font-weight-bold mr-2">Курс</small>
        </div>

        <div class="col-10">
          <div>
            <small class="mr-2">{{ duration }}</small>

            <small class="mr-2">
              {{formatDate(prescription.startDate)}} - {{formatDate(prescription.finishDate)}}
            </small>
          </div>

          <div>
            <small class="mr-2">
              {{prescription.quantity}}
              {{ declensionNumbers(prescription.quantity, prescription.drug.format.name) }}
            </small>
            <small class="mr-2">{{prescription.times.length}} р. в день</small>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-2">
          <small class="font-weight-bold mr-2">Где купить</small>
        </div>

        <div class="col-10">
          <a v-for="(stock, stockKey) in prescription.drug.stocks"
             :key="stockKey"
             :href="stock.link"
             target="blank"
             class="text-secondary d-block">
            <u>{{stock.store.name}}</u>
          </a>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-2">
          <small class="font-weight-bold mr-2">Если нет в наличии</small>
        </div>

        <div class="col-10">
          <div v-if="prescription.drug.analogs.length > 0">
            <div v-for="(analog, analogKey) in prescription.drug.analogs" :key="analogKey">
              <span>{{analog.name}}</span>

              <small>
                {{analog.measure}}
                {{analog.measureUnit}}
                {{analog.manufacturer ? analog.manufacturer.name : '' }}
              </small>

              <a v-for="(analogStock, analogStockKey) in analog.stocks"
                 :key="analogStockKey"
                 :href="analogStock.link"
                 target="_blank">
                {{analogStock.store.name}}
              </a>
            </div>
          </div>

          <div v-else class="mb-2">
            <small>У этого препарата нет аналогов</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../../utils/formatDate';
  import calculateDaysCount from '../../../utils/calculateDaysCount';
  import declensionNumbers from '../../../utils/declensionNumbers';
  import {MS_IN_DAY, FORMAT_NAMES} from '../../../constants';

  export default {
    name: 'ShopListItem',

    props: ['prescription'],

    data() {
      return {
        details: false,
      };
    },

    computed: {
      totalCount() {
        const {startDate, finishDate, times, quantity} = this.prescription;
        const days = calculateDaysCount(startDate, finishDate);

        return days * times.length * quantity;
      },

      countPerPackage() {
        const packages = this.prescription.drug.packages.map(item => item.count);

        packages.sort((a, b) => a - b);

        for (const pack of packages) {
          if (pack >= this.totalCount) {
            return pack;
          }
        }

        return packages[packages.length - 1];
      },

      packagesCount() {
        return Math.ceil(this.totalCount / this.countPerPackage);
      },

      duration() {
        const startDate = new Date(this.prescription.startDate);
        const finishDate = new Date(this.prescription.finishDate);
        const compareDate = new Date(finishDate.getTime() + MS_IN_DAY);

        if (startDate.getDate() === compareDate.getDate()) {
          const yearsDiff = (compareDate.getFullYear() - startDate.getFullYear());

          return compareDate.getMonth() + (yearsDiff * 12) - startDate.getMonth() + ' мес.';
        }

        const durationInMs = compareDate.getTime() - startDate.getTime();
        const durationInDays = parseInt(durationInMs / MS_IN_DAY);

        if (durationInDays % 7 === 0 && durationInDays !== 0) {
          return durationInDays / 7 + 'нед.';
        }

        return durationInDays + 'дн.';
      },

      hasIherb() {
        const iherbStock = this.prescription.drug.stocks.find(
          stock => stock.store.name.toLowerCase().indexOf('iherb') !== -1
        );

        return typeof iherbStock !== 'undefined';
      }
    },

    methods: {
      showDetails() {
        this.details = !this.details;
      },

      formatDate(date) {
        return formatDate(new Date(date), 'd.m.y');
      },

      declensionNumbers(count, name) {
        const formatName = FORMAT_NAMES.find(item => item[0] === name);
        const [, few, one, two] = formatName || [name, name, name, name];

        return declensionNumbers(count, few, one, two);
      },
    }
  };
</script>
